import { FC } from 'react'

import styles from '../../Status.module.scss'
import { StatusView } from '../statusView/StatusView'

interface IStatusReadonlyModeProps {
  value: string
}

export const StatusReadonlyMode: FC<IStatusReadonlyModeProps> = ({ value }) => {
  return (
    <div className={styles.root}>
      <StatusView isReadonly value={value} />
    </div>
  )
}
